import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { RouteComponentProps } from "react-router-dom";
import { Link } from "react-router-dom";
import aiLogo from "../../../../assets/images/ai-model-train.png";
import aiArrow from "../../../../assets/images/ai-model-train-aarow.png";
import sapcer from "../../../../assets/images/sapcer.png";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { IProject, IApplicationState } from "../../../../models/applicationState";

export interface ISubHeaderProps extends RouteComponentProps, React.Props<PrebuiltsubHeader> {
    project: IProject;
    actions: IProjectActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
    };
}

export interface ISubHeaderState {
    subHeaderList: any[];
}

@connect(mapStateToProps)

export default class PrebuiltsubHeader
    extends React.Component<ISubHeaderProps, ISubHeaderState> {
    public state: ISubHeaderState = {
        subHeaderList: [
            { name: "Upload Files", path: "/Prebuilt/uploadfiles/:projectName/:schema?/:type?/:projectId?", active: "", fontClass: "fa fa-upload bg-color-1" },
           
        { name: " Annotate", path: "/Prebuilt/Projects/:projectName/:projectId/:type?/edit/:schema?", active: "", fontClass: "ann-ico" },  
          
       
        ]
    }

    public returnUrlPath = (path, headerName, project) => {
        
        let routePath = "";
        switch (headerName.name) {
            case "Upload Files":
                const projectId = path.params.projectId ? `${path.params.projectId}` : "";            
                routePath = `/Prebuilt/uploadfiles/${path.params.projectName}/${path.params.schema ? path.params.schema : "na"}/${path.params.type ? path.params.type : "na"}/${projectId}`;  
                break;
         
                case " Annotate":
                    routePath = `/Prebuilt/Projects/${path.params.projectName}/${path.params.projectId}/invo/edit/${path.params.schema ? path.params.schema : "na"}`;
                    break;
               
            default:
                routePath = `/dashboard`;
        }
        return routePath;
    };

    public render() {
       // debugger;
        return (
            <nav className="navbar navbar-expand-md bg-dark navbar-dark sub-nav">
                <ul className="navbar-nav nav">
                    <li className="text-right select-model-2">
                        <span className="text-uppercase"> {this.props.match.params["projectName"]} </span>
                    </li>
                    <li className="text-right">
                        <span className="nav-title">AI MODEL TRAIN </span>
                        <img src={aiArrow} />
                    </li>
                    {this.state.subHeaderList && this.state.subHeaderList.map((header, index) => {
                        header.active = header.path === this.props.match.path ? "active" : "";
                                            

                        let routeUrl = "";
                        let pointerClass = "pointer-events";
                        const analysisData = localStorage.getItem("trainResult") && localStorage.getItem("trainResult");
                         
                        if ((header.name === " Annotate") &&(this.props.match.path === "/Prebuilt/Projects/:projectName/:projectId/:type?/edit/:schema?") )
                        {
                            pointerClass = "";
                            header.active = "active";
                        }
                        
                        if ((header.name === "Upload Files") &&(this.props.match.path === "/upload-files/:projectName/:schema?/:type?/:projectId?") )
                        {
                            pointerClass = "";
                            header.active = "active";
                        }
                         
                        if (analysisData === "true") {
                            routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                            pointerClass = "";
                            
                        }

                        if(this.props.project && index === 0 && header.name === "TestFiles")
                        {
                            routeUrl = this.returnUrlPath(this.props.match, header, this.props.project);
                            pointerClass = "";
                            header.active = "active";
                        }



                        return (
                            <li key={index} className="nav-item ">
                                <Link className={`nav-link ${header.active} ${pointerClass}`}
                                    to={routeUrl}>
                                    <i className={`${header.fontClass}`} aria-hidden="true">
                                        {index && (index === 1 || index === 2) && <img src={sapcer} />}
                                    </i>
                                    <span className="">{header.name}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    }
}

